import { WALLET_ADDRESS } from "../actions/types";
const initialState = {
    walletaddress: ''
};

export default function (state = initialState, action) {
    console.log('WALLET_ADDRESS', action)
    switch (action.type) {
        case WALLET_ADDRESS:
            return { ...state, walletaddress: action.payload };
        default:
            return state;
    }
}